export * from 'react-select';
// eslint-disable-next-line deprecate/import
import Default from 'react-select';
export default Default;
